import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppState } from '../index';
import { Store } from '@ngrx/store';

import { catchError, map, mergeMap, tap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { InvoiceService } from '../../data/invoice.service';
import { InvoiceFilterService } from '../../modules/shared/filter/invoice-filter.service';
import {
    invoiceTableAddAssist,
    invoiceTableChangePage, invoiceTableChangeQuery,
    invoiceTableFailure, invoiceTableRemoveAssist,
    invoiceTableRequest,
    invoiceTableSort,
    invoiceTableSuccess
} from './invoice-table.actions';
import { selectInvoiceTableQuery } from './invoice-table.state';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class InvoiceTableEffects {

    constructor(private actions$: Actions, private invoiceService: InvoiceService, private store: Store<AppState>,
                private snackbar: MatSnackBar, private invoiceFilterService: InvoiceFilterService) {
    }

    invoiceTableRequest$ = createEffect(() => this.actions$.pipe(
        ofType(invoiceTableRequest),
        withLatestFrom(this.store.select(selectInvoiceTableQuery)),
        mergeMap(([ , query ]) => this.invoiceService.query(query).pipe(
            map((result) => {
                return invoiceTableSuccess( { totalCount: result.totalItems, page: result.page });
            })
        )),
        catchError((e) => of(invoiceTableFailure()))
    ));

    invoiceTableFailure$ = createEffect(() => this.actions$.pipe(
        ofType(invoiceTableFailure),
        tap(() => this.snackbar.open($localize`We are having difficulty communicating with the server.  Please try again later.`))
    ), { dispatch: false });

    invoiceTableChangePage$ = createEffect(() => this.actions$.pipe(
        ofType(invoiceTableChangePage),
        map(() => invoiceTableRequest())
    ));

    invoiceTableChangeSort$ = createEffect(() => this.actions$.pipe(
        ofType(invoiceTableSort),
        map(() => invoiceTableRequest())
    ));

    invoiceTableChangeQuery$ = createEffect(() => this.actions$.pipe(
        ofType(invoiceTableChangeQuery),
        map(() => invoiceTableRequest())
    ));

    invoiceTableFilterAdd$ = createEffect(() => this.actions$.pipe(
        ofType(invoiceTableAddAssist),
        withLatestFrom(this.store.select(selectInvoiceTableQuery)),
        map(([ action, query ]) => this.invoiceFilterService.applyAssist(query, action.id, action.parameter)),
        map(query => invoiceTableChangeQuery({ query }))
    ));

    invoiceTableFilterRemove$ = createEffect(() => this.actions$.pipe(
        ofType(invoiceTableRemoveAssist),
        withLatestFrom(this.store.select(selectInvoiceTableQuery)),
        map(([ action, query ]) => this.invoiceFilterService.removeAssist(query, action.id)),
        map(query => invoiceTableChangeQuery({ query }))
    ));
}
